import * as types from './mutation-types'

export default {
  [types.PERFORM_INIT] (state, result) {
    Object.assign(state.perform, result)
  },
  [types.SET_CURRENT_SESSIONS] (state, result) {
    Object.assign(state.currentSessions, result)
  },
  [types.SET_CURRENT_GROUP] (state, result) {
    Object.assign(state.currentGroup, result)
  },
  [types.SET_CURRENT_ACTOR] (state, result) {
    Object.assign(state.currentActor, result)
  },
  [types.SET_CURRENT_PRICE_LIST] (state, result) {
    // assign 之前先清空
    //state.currentPriceList = []
    Object.assign(state.currentPriceList, result)
  },
  [types.SET_CURRENT_PRICE] (state, result) {
    Object.assign(state.currentPrice, result)
  }
}



// WEBPACK FOOTER //
// ./src/store/theatreabove/mutations.js